import script from "./AnswerQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerQuestion.vue?vue&type=script&setup=true&lang=js"

import "./AnswerQuestion.vue?vue&type=style&index=0&id=71d6ba78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d6ba78"]])

export default __exports__